"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollDirection = void 0;
/**
 * The scroll direction of the notes in a sequence.
 */
class ScrollDirection {
    constructor(id) {
        this._id = id;
    }
    static fromId(id, strict = true) {
        const item = ScrollDirection._values.find((it) => it._id === id);
        if (item) {
            return item;
        }
        if (strict) {
            throw new Error(`Invalid ScrollDirection id: ${id}`);
        }
    }
    toString() {
        return this._id;
    }
    static fromRaw(raw, strict = true) {
        const parsedValue = parseInt(raw, 10);
        return ScrollDirection.fromId(parsedValue, strict);
    }
}
exports.ScrollDirection = ScrollDirection;
ScrollDirection.FromRight = new ScrollDirection(0);
ScrollDirection.FromAbove = new ScrollDirection(1);
ScrollDirection.FromBelow = new ScrollDirection(2);
ScrollDirection.FromTopRight = new ScrollDirection(3);
ScrollDirection.FromBottomRight = new ScrollDirection(4);
ScrollDirection.FromLeft = new ScrollDirection(5);
ScrollDirection.FromTopLeft = new ScrollDirection(6);
ScrollDirection.FromBottomLeft = new ScrollDirection(7);
ScrollDirection._values = [
    ScrollDirection.FromRight,
    ScrollDirection.FromAbove,
    ScrollDirection.FromBelow,
    ScrollDirection.FromTopRight,
    ScrollDirection.FromBottomRight,
    ScrollDirection.FromLeft,
    ScrollDirection.FromTopLeft,
    ScrollDirection.FromBottomLeft,
];
